import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

const BannerImageViewModal = ({ isOpen, toggle, imageUrl, bannerId }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle} className="bg-primary text-white">
        <i className="mdi mdi-image me-2"></i>Banner Image
        {bannerId && <span className="ms-2 small">(ID: {bannerId})</span>}
      </ModalHeader>
      <ModalBody className="text-center p-4">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Banner"
            className="img-fluid rounded shadow"
            style={{ maxHeight: "70vh", width: "auto", maxWidth: "100%" }}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/800x400?text=Image+Not+Found";
            }}
          />
        ) : (
          <div className="py-5">
            <i className="mdi mdi-image-off" style={{ fontSize: "3rem", color: "#6c757d" }}></i>
            <p className="mt-3 text-muted">No image available</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <i className="mdi mdi-close me-2"></i>Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BannerImageViewModal;

